import { render, staticRenderFns } from "./TalentPrivacyPolicy.vue?vue&type=template&id=49294aec&scoped=true&"
import script from "./TalentPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./TalentPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TalentPrivacyPolicy.vue?vue&type=style&index=0&id=49294aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49294aec",
  null
  
)

component.options.__file = "TalentPrivacyPolicy.vue"
export default component.exports